module.exports = require("./ar-AE.d.ts");